import React from "react";
import { BoneIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
export function Hero() {
  return <header className="bg-paper" data-id="element-170" data-mp="cxxo1mtwnx8q">
      <div className="mx-auto max-w-5xl px-5 pb-16 pt-8 text-center sm:pt-12" data-id="element-171" data-mp="hvgzkez7xvwz">
        <div className="flex flex-wrap items-center justify-center gap-2.5" data-id="element-172" data-mp="mu0ngkxdhhrz">
          <span className="flex items-center gap-2" data-id="element-173" data-mp="mrxze6fs5ypw">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-sky" data-id="element-174" data-mp="quu9t9v62oir">
              <BoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-175" data-mp="vm2nii3j4w1q" />
            </span>
            <span className="font-display text-xl font-bold text-ink" data-id="element-176" data-mp="10lypycwkwff6">
              Safe Spine <span className="text-brand" data-id="element-177" data-mp="15kifsoeambct">Method™</span>
            </span>
          </span>
        </div>

        <p className="mx-auto mt-6 max-w-2xl font-display text-lg italic text-navy sm:text-xl" data-id="element-178" data-mp="1ajd5maaoh06f">
          “I created this because I know what it feels like to have the knowledge… but still wonder what to do next.”
        </p>

        <h1 className="mx-auto mt-5 max-w-4xl font-display text-[34px] font-black leading-[1.08] text-ink sm:text-5xl lg:text-[58px]" data-id="element-179" data-mp="4nohw3j85gp1">
          Organize your evaluation and treatment process for herniated disc patients in{" "}
          <em className="text-brand" data-id="element-180" data-mp="3rv8nry3bx9vw">less than 15 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-181" data-mp="sd920pr46jzw">
          A practical clinical system to help physical therapists evaluate, organize findings, plan sessions, and structure
          follow-up with greater clarity. Includes <strong className="text-ink" data-id="element-182" data-mp="en5l8eb07ihu">6 premium volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-183" data-mp="ekt7kdca3ual">5 professional bonuses</strong>, checklists, decision maps, protocols, and
          real-world educational cases.
        </p>

        <img src={images.mockup} alt="Safe Spine Method™ — 6 premium volumes, 5 bonuses, checklists and reasoning maps" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-184" data-mp="16d0kb2onymjp" />

        <div className="mt-6" data-id="element-185" data-mp="35jp6p7bhm32h">
          <CtaButton id="hero-cta" label="Get the Safe Spine Method™" caption="Instant Access · One-Time Payment of $27 · Lifetime Access · 7-Day Guarantee" data-id="element-186" data-mp="35n36q8woi06r" />
        </div>

        <div className="mt-8" data-id="element-187" data-mp="2hvfpkip7y3ho">
          <Countdown data-id="element-188" data-mp="2hv667dyoiuky" />
        </div>

        <p className="mt-5 text-[17px] font-semibold text-ink" data-id="element-189" data-mp="2hu4lsivrwvqk">
          Get lifetime access today for just <span className="text-brand" data-id="element-190" data-mp="2mvtvnv79f3d2">$27</span>.
        </p>

        <div className="mt-6" data-id="element-191" data-mp="27ybcr9h9jkdj">
          <ScarcityBar data-id="element-192" data-mp="27z2v3ilunllv" />
        </div>

        <p className="mx-auto mt-4 max-w-md text-sm text-muted" data-id="element-193" data-mp="2cw31jumm2qdi">
          Currency conversion is automatically handled according to your country.
        </p>
      </div>
    </header>;
}